import React, { useEffect, useState } from "react";
import { Box } from "@material-ui/core";
import { DataGrid } from "@material-ui/data-grid/";
import { useSelector } from "react-redux";
import {
  ButtonLink,
  getSiteSpecificStatus,
  statusColor,
  getSiteSpecific_price_our,
  get_price_our,
} from "../../../../lib";
import { WatchActions } from "../../../../state";
import { format } from "date-fns";
export function RecentlyAddedRecords(props) {
  const siteId = useSelector((state) => state.scopes.site_id);
  const [rows, setRows] = useState([]);

  useEffect(() => {
    (async function () {
      const recentlyAdded = await WatchActions.getRecentHistory(siteId);
      setRows(recentlyAdded);
    })();
  }, [siteId]);

  const renameValues = rows?.map((row) => ({
    id: row.item_id,
    model_no: row.model_no,
    date: format(new Date(row.act_date_added), "MMM-do yyyy"),
    addedBy:
      row.item_add_field?.user?.first_name +
      " " +
      row.item_add_field?.user?.last_name,
    price: getSiteSpecific_price_our(row, siteId),
    status: getSiteSpecificStatus(row, siteId),
    button: row.item_id,
  }));

  const columns = [
    {
      field: "id",
      headerName: "ID",
      flex: 0.4,
      headerAlign: "center",
      align: "center",
    },
    { field: "date", headerName: "Date", flex: 0.5 },
    {
      field: "model_no",
      headerName: "Model",
      flex: 1.5,
      headerAlign: "left",
      align: "left",
    },
    {
      field: "status",
      headerName: "Status",
      flex: 0.4,
      renderCell: (params) => {
        return statusColor(params.value);
      },
      filterable: false,
    },
    {
      field: "price",
      flex: 0.5,
      headerName: "Price",
      renderCell: (params) => {
        return get_price_our(params.value, siteId);
      },
    },

    {
      field: "addedBy",
      headerName: "Added By",
      flex: 0.5,
      headerAlign: "left",
      align: "left",
    },
    {
      field: "button",
      headerName: "Edit Watch",
      flex: 0.5,
      filterable: false,
      renderCell: (params) => {
        let link = `/edit-watch/${params.value}`;
        return (
          <ButtonLink
            variant="outlined"
            color="primary"
            size="small"
            to={link}
          >
            View
          </ButtonLink>
        );
      },
      headerAlign: "left",
      align: "left",
    },
  ];

  return (
    <Box
      style={{
        width: "100%",
      }}
    >
      <div style={{ display: "flex", justifyContent: "center" }}></div>

      <div>
        {rows && (
          <DataGrid
            rows={renameValues}
            columns={columns}
            disableColumnMenu={true}
            isRowSelectable={false}
            pageSize={100}
            checkboxSelection={false}
            autoHeight={true}
            rowHeight={38}
            sortModel={[
              {
                field: "id",
                sort: "desc",
              },
            ]}
          />
        )}
      </div>
    </Box>
  );
}
